// extracted by mini-css-extract-plugin
export var content = "_nb-1";
export var fullScreen = "_nb-0";